import React from "react";
import classNames from "classnames";

type ThreeColumnProps = {
  columnOne?: React.ReactNode;
  columnTwo: React.ReactNode;
  columnThree: React.ReactNode;
  className?: string;
};

const ThreeColumn = ({
  columnOne,
  columnTwo,
  columnThree,
  className,
}: ThreeColumnProps) => {
  return (
    <div
      className={classNames(
        "grid grid-cols-1 max-w-[1440px] mx-auto",
        columnOne
          ? "lg:grid-cols-[150px_20fr_13fr]"
          : "lg:grid-cols-[20fr_13fr]",
        className
      )}
    >
      {columnOne && (
        <div className="p-5 max-w-xl lg:max-w-none mx-auto w-full lg:w-auto place-self-center">
          {columnOne}
        </div>
      )}
      <div className="p-5 max-w-xl mx-auto">{columnTwo}</div>
      <div className="flex items-center bg-secondary-100 lg:m-5 lg:rounded-lg">
        {columnThree}
      </div>
    </div>
  );
};

export default ThreeColumn;
